(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminPerformanceEditSettingsController', AdminPerformanceEditSettingsController);

    function AdminPerformanceEditSettingsController(
        $controller,
        $state,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        elbSettings,
        module,
        fileTypeService,
        modulesService
    ) {
        const vm = this;
        vm.patrolsEnabled = modulesService.isEnabled('patrols_module');
        vm.surveysEnabled = modulesService.isEnabled('surveys_module');
        vm.quotesModuleEnabled = modulesService.isEnabled('quotes');
        const base = $controller('AdminEditSettingsController', {
            $state: $state,
            messenger: messenger,
            moment: moment,
            lodash: lodash,
            apiClient: apiClient,
            settingsCollection: settingsCollection,
            settingsFields: [
                'performance_system_score_weight',
                ...(vm.quotesModuleEnabled ? ['performance_quote_score_weight'] : []),
                ...(vm.surveysEnabled ? ['performance_include_survey_score', 'performance_survey_score_weight'] : []),
                // Patrol-related settings are only available when Patrols module is enabled
                ...(vm.patrolsEnabled ? ['performance_include_patrol_score', 'performance_patrol_score_weight'] : [])
            ],
            elbSettings: elbSettings,
            module: module,
            fileTypeService: fileTypeService,
            validateTabSettings: null,
            buildTabSettingFormTypes: () => ({
                ...(vm.patrolsEnabled ? { 'performance_include_patrol_score': { type: 'checkbox', notRequired: false } } : {}),
                ...(vm.surveysEnabled ? { 'performance_include_survey_score': { type: 'checkbox', notRequired: false } } : {}),
                ...(vm.patrolsEnabled ? { 'performance_patrol_score_weight': { type: 'number', options: { invalid: false} } } : {}),
                ...(vm.quotesModuleEnabled ? { 'performance_quote_score_weight': { type: 'number', options: { invalid: false} } } : {}),
                ...(vm.surveysEnabled ? { 'performance_survey_score_weight': { type: 'number', options: { invalid: false} } } : {}),
                'performance_system_score_weight': { type: 'number', options: { invalid: false} }
            })
        });

        angular.extend(vm, base);
    }
})();
